import { defineCopy } from '@/i18n'

export default defineCopy('projects', {
  id: {
    title: 'Proyek Kami',
    crumb: 'Proyek',
    intro: {
      title: { pre: 'Proyek ', hl: 'Terbaru', post: ' Kami' },
      sub: 'Berikut beberapa proyek yang telah kami kerjakan untuk klien kami.',
    },
    items: {
      school: {
        name: 'Sistem Informasi Sekolah',
        description: 'Aplikasi mobile manajemen sekolah terintegrasi dengan modul keuangan, absensi, penilaian, dan agenda siswa. Mendukung pembayaran digital dan pemantauan tagihan secara real-time.',
      },
      pension: {
        name: 'Sistem Informasi Dana Pensiun',
        description: 'Platform manajemen investasi dana pensiun dengan fitur pengelolaan investasi (Deposito, Obligasi, Saham, dll), keuangan, dan pelaporan transaksi. Dilengkapi dashboard analitik dan audit trail.',
      },
      banking: {
        name: 'Core Banking System',
        description: 'Sistem perbankan inti dengan dashboard monitoring dana masuk, analitik sumber dana, pengelolaan kas, dan pelaporan keuangan komprehensif.',
      },
    },
  },
  en: {
    title: 'Our Projects',
    crumb: 'Projects',
    intro: {
      title: { pre: 'Our ', hl: 'Latest', post: ' Projects' },
      sub: 'Here are some of the projects we have built for our clients.',
    },
    items: {
      school: {
        name: 'School Information System',
        description: 'An integrated school management mobile app with finance, attendance, grading, and student schedule modules. Supports digital payments and real-time bill tracking.',
      },
      pension: {
        name: 'Pension Fund Information System',
        description: 'A pension fund investment management platform covering investments (deposits, bonds, stocks, and more), finance, and transaction reporting. Includes an analytics dashboard and audit trail.',
      },
      banking: {
        name: 'Core Banking System',
        description: 'A core banking system with dashboards for monitoring incoming funds, funding source analytics, cash management, and comprehensive financial reporting.',
      },
    },
  },
})
